import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LETTERS = ["N", "E", "E", "D"];

export const SplashScreen = () => {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("need_splash");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return;
    try {
      sessionStorage.setItem("need_splash", "1");
    } catch {}
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[100] grid place-items-center bg-cream"
          exit={{ opacity: 0, transition: { duration: 0.45, ease: "easeOut" } }}
        >
          {/* glow orbs Dark Dopamine */}
          <div className="pointer-events-none absolute -left-24 top-1/4 h-72 w-72 rounded-full bg-sage/25 blur-[110px]" />
          <div className="pointer-events-none absolute -right-24 bottom-1/4 h-72 w-72 rounded-full bg-terra/20 blur-[110px]" />

          <div className="relative flex flex-col items-center">
            <div className="flex items-baseline overflow-hidden">
              {LETTERS.map((l, i) => (
                <motion.span
                  key={i}
                  initial={{ y: 56, opacity: 0, filter: "blur(8px)" }}
                  animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
                  transition={{ delay: 0.15 + i * 0.09, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                  className="notranslate font-serif text-7xl font-medium tracking-tight text-ink"
                  translate="no"
                >
                  {l}
                </motion.span>
              ))}
              <motion.span
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: [0, 1.4, 1], opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.5, ease: "easeOut" }}
                className="ml-1 h-3 w-3 rounded-full bg-sage shadow-[0_0_24px_rgba(255,106,44,0.9)]"
              />
            </div>
            <motion.p
              initial={{ opacity: 0, letterSpacing: "0.1em" }}
              animate={{ opacity: 1, letterSpacing: "0.35em" }}
              transition={{ delay: 0.7, duration: 0.7, ease: "easeOut" }}
              className="mt-4 text-[11px] uppercase text-ink-soft"
            >
              Essenziali mensili
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
